import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import urls from "../urls";
import type { GeneratorOverview } from "../utils/backend-types";

export const variantGeneratorsQueries = {
  all: () =>
    queryOptions({
      queryKey: ["generators"]
    }),
  detail: (variantId: number) =>
    queryOptions({
      queryKey: ["generators", { variantId }],
      queryFn: () => fetchVariantGenerators(variantId)
    })
};

export function useVariantGenerators(variantId: number) {
  return useQuery(variantGeneratorsQueries.detail(variantId));
}

async function fetchVariantGenerators(variantId: number) {
  const response = await apiWithoutCamelization.get<Array<GeneratorOverview>>(
    urls.apiWithoutCamelization.generatorsByVariant(variantId)
  );

  return response.data;
}
